var ACTION_TYPES = {
    AUTH_SET_STATE: 'AUTH_SET_STATE',
    MENU_SET_STATE: 'MENU_SET_STATE',
    ERROR_SET_STATE: 'ERROR_SET_STATE',
    ERROR_SET_ERROR: 'ERROR_SET_ERROR',
};
export { ACTION_TYPES };
//# sourceMappingURL=ActionTypes.js.map